"use client";

/**
 * FooterBottom.tsx
 *
 * Sub-component for the very bottom of the footer.
 * Contains copyright notice and policy/term links.
 */

import React from "react";
import Link from "next/link";

interface LinkItem {
  label: string;
  href: string;
}

interface FooterBottomProps {
  copyright: string;
  privacy: LinkItem;
  terms: LinkItem;
}

const FooterBottom = ({ copyright, privacy, terms }: FooterBottomProps) => {
  return (
    <div className="mt-20 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between text-xs font-bold tracking-widest uppercase text-gray-500 gap-4">
      {/* ── Copyright ── */}
      <p>{copyright}</p>

      {/* ── Policy Links ── */}
      <div className="flex items-center space-x-6">
        <Link
          href={privacy.href}
          className="hover:text-white transition-colors"
        >
          {privacy.label}
        </Link>
        <Link href={terms.href} className="hover:text-white transition-colors">
          {terms.label}
        </Link>
      </div>
    </div>
  );
};

export default FooterBottom;
